const hexChars : string[] = (() =>
{
	const chars = new Array(256);
	for(let n = chars.length; --n >= 0; )
		chars[n] = n.toString(16).padStart(2, "0");
	return chars;
} )();



export class Guid
{
	static empty : Guid = new Guid(new Uint8Array(16));

	static schema = {
		default : Guid.empty,
		parse: parseGuid,
		stringify: (v : any) => v && v.toString()
	};

	value : Uint32Array;
	constructor(data : Uint8Array | string, offset : number = 0)
	{
		const bytes = new Uint8Array(16);
		if(typeof(data) == "string")
			for(let n=0; n<16; ++n, offset += 2)
				bytes[n] = parseInt( data.slice(offset, offset+2), 16 );
		else
			bytes.set(data.subarray(offset, offset + 16));
		this.value = new Uint32Array(bytes.buffer);
	}
	asBytes() : Uint8Array
	{
		return new Uint8Array(this.value.buffer);
	}
	equals(other : Guid) : boolean 
	{
		return (this.value[0] == other.value[0]) && 
			(this.value[1] == other.value[1]) && 
			(this.value[2] == other.value[2]) &&
			(this.value[3] == other.value[3]);
	}
	toString() : string
	{
		const bytes = new Uint8Array(this.value.buffer);
		let guid = "";
		for(let n=0; n<16; ++n)
			guid += hexChars[bytes[n]];
		return guid;
	}

}

export function parseGuid(value : any) : Guid | null
{
	if(value instanceof String)
		return parseGuid(value.valueOf());
	if(typeof value == "string")
		return value.length ? new Guid(value) : null;
	if(value instanceof Uint8Array)
		return new Guid(value);
	if(value instanceof Guid)
		return value;
	return null;
}
